import template from "./account-activity-interest-earnings-info.html"

ko.components.register('account-activity-interest-earnings-info', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new TransactionInfo(params, widgetInfo);
        }
    }
});

export class TransactionInfo {
    constructor(params, widgetInfo) {
        let model = params.model;

        this.model = model;
        this.date = model.FullDate;
        this.customDescription = model.CustomDescription;
        this.description = model.Description;
        this.serviceStartDate = model.ServiceStartDate;
        this.denialComment = model.DenialComment;
        this.pendedComment = model.PendedComment;
        if (model.ReimbursementDetails && model.ReimbursementDetails.length > 0) {
            let reimbursementDetail = model.ReimbursementDetails[0];
            self.paymentClearedDate = reimbursementDetail.CheckClearedDate;
        } else {
            self.paymentClearedDate = null;
        }
    }
}